export default __webpack_public_path__ + "static/media/team-gradient.b260be42.png";